import React from 'react';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import { useTranslation } from 'react-i18next';

import scss from './EmptyGallery.module.scss';
import CheckBadge from '../check-badge/CheckBadge';

function EmptyGallery() {
  const { t } = useTranslation('studio');

  return (
    <div className={scss.emptyGallery}>
      <CollectionsOutlinedIcon className={scss.icon} />
      <span className={scss.label}>{t('emptyMediaGallery')}</span>
      <span className={scss.subLabel}>{t('emptyMediaGalleryDescription')}</span>
    </div>
  );
}

export default EmptyGallery;
